import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, useState, useRef, useEffect, useMemo } from "react";
import apiResponse from "../../../../services/apiResponse";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Spinner,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import { AvField } from "availity-reactstrap-validation";

import Shimmer from "react-shimmer-effect";

import IndexBloc from "./Blocs/IndexBloc";

import Select from "react-select";

import TableActiveComponent from "./Components/TableActiveComponent";
import moment from "moment";

var reformatOptions = function (raw, label, value) {
  return raw.map(function (data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];
    newObj["data"] = data;

    return newObj;
  });
};

const IndexView = (props) => {
  // let indexBloc = new IndexBloc();
  let indexBloc = useMemo(() => new IndexBloc(), []);
  const StatusData = [
    { value: "1", label: "Semua Data" },
    { value: "2", label: "Menunggu Approval Data Keluarga" },
    { value: "3", label: "Menunggu Approval Data Pegawai" },
    { value: "4", label: "Menunggu Approval Data Pendidikan" },
  ];

  const StatusEmployee = [
    { value: "1", label: "Pensiun" },
    { value: "2", label: "Belum Pensiun" },
  ];
  const [activeTab, setactiveTab] = useState("1");
  const activeRef = useRef();
  const inactiveRef = useRef();

  const [fileUrl, setFileUrl] = useState("");
  const [modal, setModal] = useState(false);
  const [isEchelon, setIsEchelon] = useState(0);
  const [IsLoadingWorkUnit, setIsLoadingWorkUnit] = useState(false);
  const [IsLoadingWorkUnitEchleon, setIsLoadingWorkUnitEchleon] =
    useState(false);

  // Select
  const [optionUnits, setOptionUnits] = useState([]);
  const [optionUnitsEchelon, setOptionUnitsEchelon] = useState([]);

  const [optionEmployeeCategories, setOptionEmployeeCategories] = useState([]);
  const [optionEmployeeStatuss, setOptionEmployeeStatuss] = useState([]);
  const [optionEchelon, setOptionEchelon] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState({
    label: "Semua Data",
    value: "",
  });

  const [selectedUnitEchleon, setSelectedUnitEchleon] = useState({
    label: "",
    value: "",
  });

  const [selectedHiddenUnit, setSelectedHiddenUnit] = useState({
    label: "",
    value: "",
  });

  const [selectedStatus, setSelectedStatus] = useState({
    label: "Semua Data",
    value: "",
    // label: "INTERNAL",
    // value: "f3dd847a-ed83-4539-9a16-7df9048cd42b",
  });
  const [selectedStatusData, setSelectedStatusData] = useState({
    label: "Semua Data",
    value: "1",
  });
  const [slcDataStatus, setSlcDataStatus] = useState(1);

  const [selectedStatusEmployee, setSelectedStatusEmployee] = useState({
    label: "Semua Data",
    value: "",
  });
  const [selectedEchelon, setSelectedEchelon] = useState({
    label: "Semua Data",
    value: "Semua Data",
  });

  const handleSelectUnit = (selectedUnit) => {
    setSelectedUnit(selectedUnit);

    var eselon_code = selectedUnit.data.work_unit_echelon_code;
    var work_unit_uuid = selectedUnit.data.work_unit_uuid;
    var work_unit_name = selectedUnit.data.work_unit_name;
    var is_echelon =
      eselon_code &&
      typeof eselon_code === "string" &&
      eselon_code.startsWith("1") &&
      ![
        "a465cdda-2dbc-4c69-a61f-261760fafa44",
        "71e5d4f7-cbf9-45e0-9455-7d5877fb8d55",
        // "5594103e-3dbc-4367-922e-06a26cccc76d",
      ].includes(work_unit_uuid) // Mentri, Wamen, Sesmen
        ? 1
        : 0;
    setIsEchelon(is_echelon);

    if (is_echelon == 1) {
      setSelectedUnitEchleon({
        value: work_unit_uuid,
        label: work_unit_name,
      });
      indexBloc.fetchWorkUnitEchelonTwo({
        parent_uuid: work_unit_uuid,
      });
    }
  };

  const handleSelectUnitEchelon = (selectedUnit) => {
    setSelectedUnit(selectedUnit);
    setSelectedUnitEchleon(selectedUnit);
  };

  const handleSelectStatus = (selectedStatus) => {
    setSelectedStatus(selectedStatus);
  };
  const handleSelectEchelon = (sel) => {
    setSelectedEchelon(sel);
  };
  const handleSelectStatusData = (sel) => {
    setSelectedStatusData(sel);
    setSlcDataStatus(sel.value);
  };
  const handleSelectStatusEmployee = (sel) => {
    setSelectedStatusEmployee(sel);
  };

  useEffect(() => {
    // get data unit
    indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          setIsLoadingWorkUnit(true);
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            let add_filter = {
              work_unit_name_tabs: "Semua Data",
              work_unit_uuid: "",
            };
            response.unshift(add_filter);
            setOptionUnits((prevOptions) => {
              const updatedOptions = reformatOptions(
                response,
                "work_unit_name_tabs",
                "work_unit_uuid"
              );
              return updatedOptions; // Set state dengan data baru
            });
            setIsLoadingWorkUnit(false);
          }
          break;
        case apiResponse.ERROR:
          setIsLoadingWorkUnit(false);
          break;
        default:
          break;
      }
    });

    indexBloc.workUnitEchelonTwoChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          setIsLoadingWorkUnitEchleon(true);
          break;
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            setOptionUnitsEchelon((prevOptions) => {
              const updatedOptions = reformatOptions(
                response,
                "work_unit_name_tabs",
                "work_unit_uuid"
              );
              return updatedOptions; // Set state dengan data baru
            });

            setIsLoadingWorkUnitEchleon(false);
          }
          break;
        case apiResponse.ERROR:
          setIsLoadingWorkUnitEchleon(false);
          break;
        default:
          break;
      }
    });

    indexBloc.EmployeeStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            let add_filter = {
              employee_status_uuid: "",
              employee_status_name: "Semua Data",
            };
            response.unshift(add_filter);

            setOptionEmployeeStatuss(
              reformatOptions(
                response,
                "employee_status_name",
                "employee_status_uuid"
              )
            );
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.employeeCategoriesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            let add_filter = {
              employee_categories_uuid: "",
              employee_categories_name_full: "Semua Data",
            };
            response.unshift(add_filter);
            setOptionEmployeeCategories(
              reformatOptions(
                response,
                "employee_categories_name_full",
                "employee_categories_uuid"
              )
            );
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.echelonChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            let add_filter = {
              echelon_name: "",
              echelon_name: "Semua Data",
            };
            response.unshift(add_filter);
            setOptionEchelon(
              reformatOptions(response, "echelon_name", "echelon_name")
            );
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.fetchEmployeeCategories({});
    indexBloc.fetchEmployeeStatus({});
    indexBloc.fetchWorkUnit({});
    indexBloc.fetchEchelon({});

    return () => {
      console.log("unmount");
      indexBloc.workUnitChannel?.unsubscribe();
      indexBloc.workUnitEchelonTwoChannel?.unsubscribe();
      indexBloc.employeeCategoriesChannel?.unsubscribe();
      indexBloc.EmployeeStatusChannel?.unsubscribe();
      indexBloc.echelonChannel?.unsubscribe();
      indexBloc.exportExcelChannel?.unsubscribe();
    };
  }, []);

  // Filter
  const [nip, setNip] = useState("");
  const [name, setName] = useState("");

  let additionalFilter = {
    nip: nip,
    name: name,
    work_unit: selectedUnit.value || "",
    hidden_work_unit: selectedHiddenUnit.value || "",
    emp_categories: selectedStatus.value || "",
    emp_status: selectedStatusEmployee.value || "",
    echelon: selectedEchelon.value || "",
    employee_status_uuid: selectedStatusEmployee.value || "",
    status_data: slcDataStatus,
  };

  const reloadActiveRef = () => activeRef.current.setTokenAPI();
  const reloadInactiveRef = () => inactiveRef.current.setTokenAPI();

  function handleButtonSearch() {
    reloadActiveRef();
  }

  function handleButtonReset() {
    setNip("");
    setName("");
    setSelectedStatus({
      label: "Semua Data",
      value: "",
    });
    setSelectedStatusEmployee({
      label: "Semua Data",
      value: "",
    });
    setSelectedUnit({
      label: "Semua Data",
      value: "",
    });
    setSelectedEchelon({
      label: "Semua Data",
      value: "Semua Data",
    });
    setSelectedStatusData({
      label: "Semua Data",
      value: "1",
    });
    setSlcDataStatus(1);

    setTimeout(function () {
      reloadActiveRef();
    }, 100);
  }

  function handleButtonExport() {
    setModal(!modal);

    indexBloc.exportExcelChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            setFileUrl(response.file_url);
            //setModal(!modal)
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.fetchExportExcel({
      ...additionalFilter,
    });
  }

  return (
    <Fragment>
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <div className="float-end">
                  {accessRole("create") ? (
                    <Link to="home.html?create">
                      <Button color="primary">Tambah Pegawai</Button>
                    </Link>
                  ) : null}
                </div>
                <CardTitle>List Data Pegawai</CardTitle>
                <CardSubtitle className="mb-3">
                  Daftar Seluruh Pegawai
                </CardSubtitle>
                <hr />
                <Row className="mb-3">
                  <label htmlFor="gender" className="col-md-2 col-form-label">
                    Jenis Pegawai
                  </label>
                  <Col md="4">
                    <Select
                      value={optionEmployeeCategories.filter(
                        (option) => option.value === selectedStatus.value
                      )}
                      onChange={handleSelectStatus}
                      required="required"
                      options={optionEmployeeCategories}
                      classNamePrefix="select2-unit"
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <label htmlFor="gender" className="col-md-2 col-form-label">
                    Status Pegawai
                  </label>
                  <Col md="4">
                    <Select
                      value={optionEmployeeStatuss.filter(
                        (option) =>
                          option.value === selectedStatusEmployee.value
                      )}
                      onChange={handleSelectStatusEmployee}
                      required="required"
                      options={optionEmployeeStatuss}
                      classNamePrefix="select2-status_employee"
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <label htmlFor="gender" className="col-md-2 col-form-label">
                    Unit Kerja
                  </label>

                  {/* Default Unit Kerja  */}
                  {optionUnitsEchelon.length == 0 ? (
                    <Col md="4">
                      <Select
                        value={optionUnits.filter(
                          (option) => option.value === selectedUnit.value
                        )}
                        onChange={handleSelectUnit}
                        required="required"
                        options={optionUnits}
                        classNamePrefix="select2-unit"
                        isLoading={IsLoadingWorkUnit}
                      />
                    </Col>
                  ) : null}

                  {/* Unit Kerja Eselon 1 */}
                  {optionUnitsEchelon.length > 0 ? (
                    <>
                      <Col md="4">
                        <Select
                          value={optionUnitsEchelon.filter(
                            (option) =>
                              option.value === selectedUnitEchleon.value
                          )}
                          onChange={handleSelectUnitEchelon}
                          required="required"
                          options={optionUnitsEchelon}
                          classNamePrefix="select2-unit"
                          isLoading={IsLoadingWorkUnit}
                        />
                      </Col>

                      <Col md="2">
                        <Button
                          color="primary"
                          type="button"
                          onClick={() => {
                            indexBloc.fetchWorkUnit({});
                            setSelectedUnit({
                              label: "Semua Data",
                              value: "",
                            });
                            setOptionUnitsEchelon([]);
                          }}
                        >
                          <i className="uil-search-alt"></i> Tampilkan Semua
                          Unit
                        </Button>
                      </Col>
                    </>
                  ) : null}
                  {/* {optionUnitsEchelon.length > 0 ? (
                    IsLoadingWorkUnitEchleon ? (
                      <Col md="4">
                        <Shimmer>
                          <div style={{ width: "30%", height: 30 }}></div>
                        </Shimmer>
                      </Col>
                    ) : (
                      <>
                        <Col md="4">
                          <Select
                            value={optionUnitsEchelon.filter(
                              (option) =>
                                option.value === selectedUnitEchleon.value
                            )}
                            onChange={handleSelectUnitEchelon}
                            required="required"
                            options={optionUnitsEchelon}
                            classNamePrefix="select2-unit"
                            isLoading={IsLoadingWorkUnit}
                          />
                        </Col>

                        <Col md="2">
                          <Button
                            color="primary"
                            type="button"
                            onClick={() => {
                              indexBloc.fetchWorkUnit({});
                              setSelectedUnit({
                                label: "Semua Data",
                                value: "",
                              });
                              setOptionUnitsEchelon([]);
                            }}
                          >
                            <i className="uil-search-alt"></i> Tampilkan Semua
                            Unit
                          </Button>
                        </Col>
                      </>
                    )
                  ) : null} */}
                </Row>
                <Row className="mb-3">
                  <label htmlFor="gender" className="col-md-2 col-form-label">
                    Eselon
                  </label>
                  <Col md="4">
                    <Select
                      value={optionEchelon.filter(
                        (option) => option.value === selectedEchelon.value
                      )}
                      onChange={handleSelectEchelon}
                      required="required"
                      options={optionEchelon}
                      classNamePrefix="select2-unit"
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <label htmlFor="gender" className="col-md-2 col-form-label">
                    Status Data
                  </label>
                  <Col md="4">
                    <Select
                      value={StatusData.filter(
                        (option) => option.value === selectedStatusData.value
                      )}
                      onChange={handleSelectStatusData}
                      required="required"
                      options={StatusData}
                      classNamePrefix="select2-status_data"
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="2"></Col>
                  <Col md="10">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() => {
                        handleButtonSearch();
                      }}
                    >
                      <i className="uil-search-alt"></i> Cari
                    </Button>{" "}
                    <Button
                      color="warning"
                      type="button"
                      onClick={() => {
                        handleButtonReset();
                      }}
                    >
                      <i className="uil-refresh"></i> Reset
                    </Button>{" "}
                    <Button
                      color="success"
                      type="button"
                      onClick={() => {
                        handleButtonExport();
                      }}
                    >
                      <i className="uil-file-download-alt"></i> Export Data
                      Pegawai
                    </Button>
                  </Col>
                </Row>

                <hr />

                <TableActiveComponent
                  ref={activeRef}
                  handleInactiveSuccess={reloadInactiveRef}
                  additionalFilter={additionalFilter}
                  selectedStatusData={selectedStatusData}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal
        isOpen={modal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={() => {
          setModal(!modal);
        }}
      >
        <div className="modal-content">
          <ModalHeader
            toggle={() => {
              setModal(!modal);
              setFileUrl("");
            }}
          >
            Export
          </ModalHeader>
          <ModalBody>
            {fileUrl == "" ? (
              <div className="text-center">
                <Spinner className="m-1" color="primary" />
                <div>Memproses Data</div>
              </div>
            ) : (
              <>
                <Row className="mb-3">
                  <label className="col-md-4">Jenis File</label>
                  <Col md="8">Excel (xlsx)</Col>
                </Row>
                <Row className="mb-3">
                  <label className="col-md-4">Waktu Generate</label>
                  <Col md="8">
                    {moment(new Date()).format("DD/MM/YYYY HH:mm")}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <label className="col-md-4">Link</label>
                  <Col md="8">
                    <a
                      target={"_blank"}
                      className="btn btn-success"
                      href={fileUrl}
                    >
                      Download <i className="fa fa-download ms-1"></i>
                    </a>
                  </Col>
                </Row>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                setModal(!modal);
                setFileUrl("");
              }}
            >
              Kembali
            </Button>
          </ModalFooter>
        </div>
      </Modal>
    </Fragment>
  );
};

export default IndexView;
